import React from "react";
import SortTabs from "./SortTabs";
import "./FlightResultsHeader.css";

export default function FlightResultsHeader({
  resultCount,
  search,
  sortMode,
  onSortChange,
}) {
  const summary = search
    ? `${search.originCity || search.origin} → ${search.destinationCity || search.destination} · ${search.departDateLabel?.slice(0, 5) || ""}–${search.returnDateLabel?.slice(0, 5) || ""} · ${search.passengersLabel}`
    : "";

  return (
    <header className="fe2-rhead">
      <div className="fe2-rhead__text">
        <h2 className="fe2-rhead__count">{resultCount} תוצאות</h2>
        {summary ? <p className="fe2-rhead__summary">{summary}</p> : null}
      </div>
      <SortTabs value={sortMode} onChange={onSortChange} />
    </header>
  );
}
